import { render, staticRenderFns } from "./ColumnElement.vue?vue&type=template&id=f7d3be68&"
import script from "./ColumnElement.vue?vue&type=script&lang=js&"
export * from "./ColumnElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports